<div class="register-wrapper card-mode" [class.vd-card]="isVariantD">
  <div class="create-account-heading">{{ isVariantD ? 'Enter credit card details' : 'Create Account' }}</div>
  <div class="create-account-subheading">Try Rosie free for 7 days.</div>

  <div class="reg-card-step" [formGroup]="cardForm">
    <div class="reg-card-header" *ngIf="!isVariantD">
      <span class="reg-card-label">
        <img class="reg-icon" src="assets/images/lock.svg" alt="" aria-hidden="true" />
        Enter credit card details
      </span>
      <span class="reg-card-brands">
        <img src="assets/images/cards/brands-vma.png" alt="Visa, Mastercard, American Express" />
        <img src="assets/images/cards/brands-discover.png" alt="Discover" />
      </span>
    </div>
    <div class="form-group">
      <!-- Native Stripe cardNumber element (native placeholder). Brand badges on the
           right (Variant D) reduce to the detected brand and slide back when cleared.
           Whole-field click focuses the iframe so mobile taps reliably open it. The
           tap shield covers the iframe while unfocused: iOS WebKit natively flashes a
           grey rectangle over tapped cross-origin iframes (no CSS can remove it), so
           the tap must land on our own element instead. -->
      <div class="stripe-field" (click)="focusCard()">
        <div id="reg-card-number" class="stripe-mount"></div>
        <!-- Stand-in placeholder until Stripe's iframe renders its own (identical)
             one, so the fields don't sit empty while Stripe boots. -->
        <span class="stripe-placeholder" *ngIf="!cardNumberReady">Card number</span>
        <span class="reg-card-brands reg-card-brands-field" *ngIf="isVariantD">
          <img *ngFor="let brand of brands" [src]="'assets/images/cards/' + brand + '.png'"
            [alt]="brand" [class.reg-brand-hidden]="cardBrand && cardBrand !== brand" />
        </span>
        <div class="stripe-tap-shield" *ngIf="!cardNumberFocused"></div>
      </div>
    </div>
    <div class="reg-card-row">
      <div class="form-group">
        <div class="stripe-field" (click)="focusExpiry()">
          <div id="reg-card-expiry" class="stripe-mount"></div>
          <span class="stripe-placeholder" *ngIf="!cardExpiryReady">MM / YY</span>
          <div class="stripe-tap-shield" *ngIf="!cardExpiryFocused"></div>
        </div>
      </div>
      <div class="form-group">
        <div class="stripe-field" (click)="focusCvc()">
          <div id="reg-card-cvc" class="stripe-mount"></div>
          <span class="stripe-placeholder" *ngIf="!cardCvcReady">CVC</span>
          <div class="stripe-tap-shield" *ngIf="!cardCvcFocused"></div>
        </div>
      </div>
      <div class="form-group">
        <input type="text" class="form-control reg-zip" formControlName="zip" placeholder="ZIP code" />
      </div>
    </div>
    <div class="reg-card-meta">
      <button type="button" class="reg-promo-toggle" *ngIf="promoState === 'collapsed'" (click)="expandPromo()">
        <img class="reg-icon" src="assets/images/tag.svg" alt="" aria-hidden="true" />
        Apply promo code
      </button>
      <div class="reg-promo-field" *ngIf="promoState === 'expanded'">
        <div class="reg-promo-input-wrap">
          <input type="text" class="form-control reg-promo-input" formControlName="promoCode"
            placeholder="Add promotion code..." (keyup.enter)="applyPromo()" />
          <button type="button" class="reg-promo-apply" (click)="applyPromo()" [disabled]="promoInProgress">
            {{ promoInProgress ? 'Applying...' : 'Apply' }}
          </button>
        </div>
        <div class="reg-promo-error" *ngIf="promoError">{{ promoError }}</div>
      </div>
      <div class="reg-promo-applied" *ngIf="promoState === 'applied'">
        <span class="reg-promo-applied-chip">
          <img class="reg-icon" src="assets/images/tag.svg" alt="" aria-hidden="true" />
          {{ appliedPromoName }}
        </span>
        <button type="button" class="reg-promo-remove" (click)="removePromo()">
          <span class="reg-promo-remove-x" aria-hidden="true">&times;</span>
          REMOVE
        </button>
      </div>
      <span class="reg-secured">
        <img class="reg-icon" src="assets/images/lock.svg" alt="" aria-hidden="true" />
        <span class="reg-secured-text">Secured by</span>
        <img class="reg-stripe-logo" src="assets/images/stripe-group.svg" alt="Stripe" />
      </span>
    </div>
    <rosie-alert *ngIf="cardError" [message]="cardError" [type]="'error'" class="d-block mb-3"></rosie-alert>
    <rosie-button [inProgress]="cardInProgress" [customClass]="'w-100'"
      [iconSuffixConfig]="{name: 'heroArrowRight', size: '18px', strokeWidth: '2', color: '#EAD7FD'}"
      [customType]="'button'" [translationKey]="'REGISTER.SUBMIT_CARD'" (click)="submitCard()"></rosie-button>
    <div class="reg-card-disclaimer"><strong>No charge today.</strong> $49/month after your 7-day trial. Switch plans, or cancel anytime.</div>
  </div>

  <div class="d-flex justify-content-center">
    <div [innerHTML]="getTOSAndPP()" class="pp-tos-text tos-card"></div>
  </div>
</div>
